import React, { useEffect, useState } from "react";
import { httpReauest } from "../../utils/httpRequest";
import ProductCard from "../common/card/ProductCard";
import Loading from "../common/Loading";
import { useTranslation } from "react-i18next";

const TodayMenu = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    await httpReauest("GET", "/product/menu", {}, {}).then((res) => {
      setProducts(res.data.data);
    });
    setLoading(false);
  }

  return (
    <section>
      <h2 className="text-xl font-bold mb-4 text-center">{t("today-menu")}</h2>
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          <div className="grid">
            {products.map((product) => (
              <ProductCard product={product} />
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default TodayMenu;
